export default {
    container: {
        position: 'relative',
        maxWidth: '1064px',
    },
    horizontalLine: {
        display: 'flex',
        height: '1px',
        width: '100%',
        background: 'gray.300',
    },
};
